import React, { useState, useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./Resume.css";
import index from "react-typical";

export default function Resume(props) {
  const [selectedBulletIndex, setSelectedBulletIndex] = useState(0);
  const [carousalOffsetStyle, setCarousalOffsetStyle] = useState({});

  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;

    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  /* REUSABLE MINOR COMPONENTS */
  const ResumeHeading = (props) => {
    return (
      <div className="resume-heading">
        <div className="resume-main-heading">
          <div className="heading-bullet"></div>
          <span>{props.heading ? props.heading : ""}</span>
          {props.fromDate && props.toDate ? (
            <div className="heading-date">
              {props.fromDate + "-" + props.toDate}
            </div>
          ) : (
            <div></div>
          )}
        </div>
        <div className="resume-sub-heading">
          <span>{props.subHeading ? props.subHeading : ""}</span>
        </div>
        <div className="resume-heading-description">
          <span>{props.description ? props.description : ""}</span>
        </div>
      </div>
    );
  };

  /* STATIC RESUME DATA FOR THE LABELS*/
  const resumeBullets = [
    { label: "Education", logoSrc: "education.svg" },
    { label: "Programming Skills", logoSrc: "programming-skills.svg" },
    { label: "Projects", logoSrc: "projects.svg" },
    { label: "Interests", logoSrc: "interests.svg" },
  ];

  //here we have
  const programmingSkillsDetails = [
    { skill: "Web Technologies", ratingPercentage: 90 },
    { skill: "React JS", ratingPercentage: 80 },
    { skill: "React Native", ratingPercentage: 50 },
    { skill: "Java", ratingPercentage: 90 },
    { skill: "Node  and Express JS", ratingPercentage: 60 },
    { skill: "Type Script", ratingPercentage: 95 },
    { skill: "Flutter and Dart", ratingPercentage: 80 },
    { skill: "Angular", ratingPercentage: 100 },
    { skill: "SQL", ratingPercentage: 90 },
    { skill: "MongoDB", ratingPercentage: 90 },
  ];

  const projectsDetails = [
    {
      title: "CMR (Customer Management Relationship)",
      duration: { fromDate: "25/04/2024", toDate: "02/06/2024" },
      description:
        "A Customer Management Relationship project developed during my work at Datavalley.ai, focusing on managing customer interactions, data, and business processes efficiently.",
      subHeading:
        "Technologies Used: Frontend - React.js, HTML, CSS, Bootstrap, JavaScript | Backend - Node.js, Express.js | Database - MongoDB",
    },
    {
      title: "Travel-Advisor ",
      duration: { fromDate: "12/07/2023", toDate: "22/07/2023" },
      description:
        "Travelling persons can easily find the best places,resturants,hotels in any location and help them to know their locations",
      subHeading:
        "Technologies Used: HTML, CSS, ReactJS,Google-Maps API, Bootstrap.",
    },
    {
      title: "Book-library",
      duration: { fromDate: "03/03/2023", toDate: "25/04/2023" },
      description:
        "Search a book in that library app and read it nearly 1000+ books are avaliable to help students",
      subHeading: "Technologies Used:HTML,CSS,ReactJS,Rapid API'S,Bootstrap.",
    },
  ];

  const resumeDetails = [
    <div className="resume-screen-container" key="education">
      <ResumeHeading
        heading={"A.M. REDDY MEMORIAL COLLEGE OF ENGINEERING AND TECHNOLOGY"}
        subHeading={"M.Tech : COMPUTER SCIENCE AND ENGINEERING"}
        fromDate={"2025"}
        toDate={"2027"}
      />

      <ResumeHeading
        heading={"Dr Sri Sri Sri Shivakumar Mahaswamy College Of Engineering"}
        subHeading={"B.Tech : COMPUTER SCIENCE AND ENGINEERING"}
        fromDate={"2019"}
        toDate={"2023"}
      />

      <ResumeHeading
        heading={"BEST Pu College "}
        subHeading={"PUC: PCMB"}
        fromDate={"2017"}
        toDate={"2019"}
      />

      <ResumeHeading
        heading={"Polaramma High School"}
        subHeading={"Schooling"}
        fromDate={"2016"}
        toDate={"2017"}
      />
    </div>,

    /* PROGRAMMING SKILLS */
    <div
      className="resume-screen-container programming-skills-container"
      key="programming-skills"
    >
      {programmingSkillsDetails.map((skill, index) => (
        <div className="skill-parent" key={index}>
          <div className="heading-bullet"></div>
          <span>{skill.skill}</span>
          <div className="skill-percentage">
            <div
              style={{ width: skill.ratingPercentage + "%" }}
              className="active-percentage-bar"
            ></div>
          </div>
        </div>
      ))}
    </div>,

    /* PROJECTS */
    <div className="resume-screen-container" key="projects">
      {projectsDetails.map((projectsDetails, index) => (
        <ResumeHeading
          key={index}
          heading={projectsDetails.title}
          subHeading={projectsDetails.subHeading}
          description={projectsDetails.description}
          fromDate={projectsDetails.duration.fromDate}
          toDate={projectsDetails.duration.toDate}
        />
      ))}
    </div>,

    /* Interests */
    <div className="resume-screen-container" key="interests">
      <ResumeHeading
        heading="Competitive Programming"
        description="I like to challenge my reflexes a lot while competing in Programming, pushing the rank and having interactive Learning sessions excites me the most."
      />
      <ResumeHeading
        heading="Music"
        description="Listening to soothing music is something i can never compromise with, skimming through Spotify's pop songs charts is at times the best stress reliever that i can get my hands on."
      />
      <ResumeHeading
        heading="Playing Games"
        description="I like to challenge my reflexes a lot while competing in games, pushing the rank and having interactive gaming sessions excites me the most."
      />
    </div>,
  ];

  const handleCarousal = (index) => {
    let offsetHeight = 360;

    let newCarousalOffset = {
      style: { transform: "translateY(" + index * offsetHeight * -1 + "px)" },
    };

    setCarousalOffsetStyle(newCarousalOffset);
    setSelectedBulletIndex(index);
  };
  const getBullets = () => {
    return resumeBullets.map((bullet, index) => (
      <div
        onClick={() => handleCarousal(index)}
        className={
          index === selectedBulletIndex ? "bullet selected-bullet" : "bullet"
        }
        key={index}
      >
        <img
          className="bullet-logo"
          src={require(`../../assets/Resume/${bullet.logoSrc}`).default}
        />
        <span className="bullet-label">{bullet.label}</span>
      </div>
    ));
  };
  const getResumeScreens = () => {
    return (
      <div
        style={carousalOffsetStyle.style}
        className="resume-details-carousal"
      >
        {resumeDetails.map((ResumeDetail) => ResumeDetail)}
      </div>
    );
  };
  return (
    <div
      className="resume-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="resume-content">
        <ScreenHeading title={"Resume"} subHeading={"My formal Bio Details"} />
        <div className="resume-card">
          <div className="resume-bullets">
            <div className="bullet-container">
              <div className="bullet-icons"></div>
              <div className="bullets">{getBullets()}</div>
            </div>
          </div>

          <div className="resume-bullet-details">{getResumeScreens()}</div>
        </div>
      </div>
    </div>
  );
}
